export function useUrlParameter(name:string):string|null{
  const queryString:string = window.location.search;
  const urlParams:URLSearchParams = new URLSearchParams(queryString);
  const val:string|null = urlParams.get(name);
  return val;
}
